import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { Listing } from 'ha/services/apiV2/types/Listing';
import { APIV2_URL } from './constants';

export default (makeCall: MakeCall) => (listingId: number) =>
  makeCall<Listing>('POST', `${APIV2_URL}/listing/${listingId}/copy`);

export type DuplicateListingCall = (
  listingId: number,
) => Promise<{ data: Listing }>;
